import React, { FC } from 'react';
import styled from '@emotion/styled';

import { AnyImage } from 'src/components';
import Emoji from './emoji';

type Props = {
  title: string;
  description: string;
  image?: string;
  emoji?: string;
  reverse: boolean;
  addon?: JSX.Element;
};

const ProjectItemBase: React.FCX<Props> = ({
  className,
  image,
  title,
  description,
  emoji,
  addon,
}) => (
  <div className={className}>
    <div>
      <div>
        <h3>{title}</h3>
        {image && <AnyImage filename={image} />}
        {emoji && <Emoji emoji={emoji} />}
      </div>
      <p>{description}</p>
      {addon}
    </div>
  </div>
);

const ProjectItem = styled(ProjectItemBase)`
  width: 90%;
  height: 300px;
  width: 100%;
  margin: 2em;
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  justify-content: center;
  line-height: 1.3;
  position: relative;
  background-color: var(--color-primary-dark);

  @media screen and (min-width: 768px) {
    width: 350px;
    height: 350px;
  }

  & > div {
    padding: 2em;
    z-index: 2;
    color: var(--color-text-inverse);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  & > div > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  img {
    width: 100px;
    height: 100px;
  }

  h3 {
    position: relative;
    font-weight: 500;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
  }
  &:before {
    background-color: #fff;
    transform: rotate(-3deg);
    z-index: 1;
  }
  &:after {
    background-color: var(--color-primary-dark);
    transform: rotate(3deg);
    z-index: 1;
  }
`;

export default ProjectItem;
